/*
 * Jackson layout for the Amazon Reviews by Appio grid (Figma 32:2561).
 *
 * Appio's masonry picks its column count in JS from Appio.CARD_MIN_WIDTH, which it
 * resets to 250px on every restyle, so CSS alone gives 4-5 columns. We pin the card
 * minimum so desktop gets the design's 3 columns (1 below 1000px, like js-reviews)
 * and the design's 16px gutter at every width (Appio drops to 10px on mobile).
 * Relies on Appio internals: if an app update renames them this quietly does
 * nothing and Appio's own grid shows instead.
 */
(() => {
  const DESKTOP_MIN_CARD = 380;
  const SINGLE_COLUMN = 100000;
  const GUTTER = 16;

  const patch = (appio) => {
    if (appio.__jacksonGrid) return;
    appio.__jacksonGrid = true;

    Object.defineProperty(appio, 'CARD_MIN_WIDTH', {
      configurable: true,
      get: () => (window.innerWidth >= 1000 ? DESKTOP_MIN_CARD : SINGLE_COLUMN),
      set: () => {},
    });

    Object.defineProperty(appio, 'CARD_SPACING', {
      configurable: true,
      get: () => GUTTER,
      set: () => {},
    });

    if (typeof appio.buildGrid === 'function') {
      appio.buildGrid();
      appio.buildGrid(true);
    }
  };

  let tries = 0;
  const wait = () => {
    if (window.Appio && 'CARD_MIN_WIDTH' in window.Appio) {
      patch(window.Appio);
    } else if (tries++ < 100) {
      setTimeout(wait, 100);
    }
  };

  wait();
})();
